import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { FachbereichActions, FachbereichActionTypes } from '../../actions/mdqx/fachbereich.actions';
import { FachbereichEntity } from '../../../entities/mdqx/fachbereich.entity';

export interface FachbereichState extends EntityState<FachbereichEntity> {
    fetched: boolean;
}

export const FACHBEREICH_KEY = 'fachbereich';

const adapter = createEntityAdapter<FachbereichEntity>({
    selectId: fachbereich => fachbereich.Id,
});

const initialState: FachbereichState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function fachbereichReducer(state = initialState, action: FachbereichActions) {
    switch (action.type) {
        case FachbereichActionTypes.GetResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllFachbereiche = selectAll;

export const selectFachbereicheFetched = (state: FachbereichState) => state.fetched;
